import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_RICH_PLACEMENT_MULTI_ANCHOR: TypedDocumentNode<Data, Variables> = gql`
  query getRichPlacementMultiAnchor($workspaceId: ID!) {
    workspaceRichPlacementMultianchorConfiguration(workspaceId: $workspaceId) {
      customStyling
      displayAfterUserInteractionEnabled
      fullWidthModeEnabled
      showCloseButtonEnabled
      singleAdViewTime
    }
  }
`
